<!--suppress JSUnusedLocalSymbols -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'RECETAS' }]">
      </app-breadcrumb>
    </div>

    <app-top-widgets></app-top-widgets>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="content-block">
            @if (userRole != UserRole.Medico && userRole != UserRole.Particular) {
              <div class="row m-2">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <mat-form-field appearance="outline" class="dropdown example-full-width" data-tour="rx-filter-gemp">
                    <mat-label>GRUPO EMPRESARIAL</mat-label>
                    <mat-select
                      (selectionChange)="onBranchChange(idGEMP!)"
                      [(ngModel)]="idGEMP"
                      [disabled]="!isAdmin">
                      @for (grupo of businessGroups; track grupo) {
                        <mat-option [value]="grupo.idGEMP">
                          {{ grupo.nombre }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <mat-form-field appearance="outline" class="dropdown example-full-width" data-tour="rx-filter-sucursal">
                    <mat-label>SUCURSAL</mat-label>
                    <mat-select [(ngModel)]="idSucursal" [disabled]="!isAdmin">
                      @for (sucursal of branches; track sucursal) {
                        <mat-option [value]="sucursal.idSucursal">
                          {{ sucursal.nombre }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
            <div class="row m-2">
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <mat-form-field appearance="outline" class="date-field example-full-width" data-tour="rx-filter-fecha-inicial">
                  <mat-label>FECHA INICIAL</mat-label>
                  <input
                    (dateChange)="onDateChange()"
                    [(ngModel)]="filterReceta.startDate"

                    [matDatepicker]="fechaInicial"
                    aria-autocomplete="none"
                    autocomplete="nope"
                    matInput
                  />
                  <button
                    (click)="clearDate('startDate')"
                    *ngIf="filterReceta.startDate"
                    aria-label="Clear Fecha Inicial"
                    mat-icon-button
                    matSuffix
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-datepicker-toggle [for]="fechaInicial" matSuffix></mat-datepicker-toggle>
                  <mat-datepicker #fechaInicial></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">

                <mat-form-field appearance="outline" class="date-field example-full-width" data-tour="rx-filter-fecha-final">
                  <mat-label>FECHA FINAL</mat-label>
                  <input
                    (dateChange)="onDateChange()"
                    [(ngModel)]="filterReceta.endDate"

                    [matDatepicker]="fechaFinal"
                    aria-autocomplete="none"
                    autocomplete="nope"
                    matInput
                  />
                  <button
                    (click)="clearDate('endDate')"
                    *ngIf="filterReceta.endDate"
                    aria-label="Clear Fecha Final"
                    mat-icon-button
                    matSuffix
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-datepicker-toggle [for]="fechaFinal" matSuffix></mat-datepicker-toggle>
                  <mat-datepicker #fechaFinal></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <mat-form-field appearance="outline" class="dropdown example-full-width" data-tour="rx-filter-periodo">
                  <mat-label>DIA, MES, AÑO</mat-label>
                  <mat-select (selectionChange)="onDateFilterChange()" [(ngModel)]="filterReceta.dateFilter" data-tour="rx-filter-periodo-select">
                    @for (opcion of opcionesDiaMesAnio; track opcion) {
                      <mat-option [value]="opcion" [attr.data-tour]="opcion === 'Mes' ? 'rx-filter-periodo-mes' : null">
                        {{ opcion }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <mat-form-field appearance="outline" class="example-full-width" data-tour="rx-filter-folio">
                  <mat-label>Folio</mat-label>
                  <input
                    [(ngModel)]="filterReceta.folio"
                    aria-autocomplete="none"
                    autocomplete="nope"
                    matInput
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <button (click)="buscar()" data-tour="rx-filter-btn-buscar" class="mt-1" color="primary" mat-raised-button>BUSCAR</button>
              </div>
            </div>
          </div>
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-search-box">
                  <label><i class="material-icons search-icon">search</i></label>
                  <input
                    data-tour="rx-table-search"
                    #filter
                    aria-autocomplete="none"
                    aria-label="Search box" autocomplete="nope" class="browser-default search-field"
                    placeholder="BUSCAR"
                    type="text">
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">
                @if (isDoctor || isParticular) {
                  <li class="tbl-header-btn">
                    <div class="m-l-10" matTooltip="CREAR">
                      <button (click)="addNew()" color="primary" mat-mini-fab data-tour="rx-btn-add">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </li>
                }
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="RECARGAR">
                    <button (click)="refresh()" color="primary" mat-mini-fab data-tour="rx-btn-refresh">
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                </li>
                <li>
                  <div class="export-button m-l-10" matTooltip="EXCEL">
                    <img (click)="exportExcel()" data-tour="rx-btn-excel" alt="" height="512" ngSrc="assets/images/icons/xlsx.png" width="512"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="body overflow-auto">
            <div class="responsive_table" data-tour="rx-table">
              <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>
                <ng-container matColumnDef="folio">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>FOLIO DE LA RECETA</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.folio}}"><span class="mobile-label">FOLIO:</span>
                    <div class="block">
                      <span class="prop_four">{{ row.folio ? row.folio : 'SIN FOLIO' }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="medico">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> MEDICO</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.nombreMedico}}"><span
                    class="mobile-label">Medico: </span>
                    <div class="block">
                      <span class="prop_one">
                            {{ row.nombreMedico }}
                      </span>
                      <span class="prop_two">Ced. {{ row.cedulaGeneral }}</span>
                      <span
                        class="prop_two">Especialidad: {{ row.especialidad ? row.especialidad : 'Sin especialidad' }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="paciente">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> PACIENTE</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.nombrePaciente}}"><span
                    class="mobile-label">Paciente: </span>
                    <div class="block">
                      <span class="prop_one">
                            {{ row.nombrePaciente }}
                      </span>
                      <span class="prop_two">Edad: {{ row.edad }} años</span>

                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="diagnostico">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> DIAGNOSTICO
                    <span style="margin-left: 10em;">
<!--                      este span lo que hace es poner espacio , no bortrar-->
                    </span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span class="mobile-label">DIAGNOSTICO: </span>
                    <div class="block">
                      <!-- Si hay diagnostico -->
                      <ng-container *ngIf="row.patologias && row.patologias !== 'CIM10 CLASSIFICATION'; else sinDiag">
                        <ng-container *ngIf="!row.expandirDiagnostico">
                          <div class="block">
                            <span class="prop_two ellipsis-diagnostico" [matTooltip]="row.patologias">
                              {{ row.patologias.length > 80 ? row.patologias.slice(0, 80) + '...' : row.patologias }}
                            </span>
                          </div>
                          <span
                            *ngIf="row.patologias.length > 80"
                            class="leer-mas"
                            (click)="expandirDiagnostico(row)">
                            Leer mas
                          </span>
                        </ng-container>
                        <ng-container *ngIf="row.expandirDiagnostico">
                          <div class="block">
                            <span class="prop_two">
                              {{ row.patologias }}
                            </span>
                            <span class="leer-mas" style="display: block;" (click)="expandirDiagnostico(row, false)">
                              Leer menos
                            </span>
                          </div>
                        </ng-container>

                      </ng-container>
                      <ng-template #sinDiag>
                        <span class="prop_two sin-diagnostico">SIN DIAGNOSTICO</span>
                      </ng-template>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="gemp">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> GRUPO Y SUCURSAL
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.grupoEmpresarial}}"><span
                    class="mobile-label">Grupo y Sucursal: </span>
                    <div class="block">
                      <span class="prop_one">
                            {{ row.grupoEmpresarial }}
                      </span>
                      <span class="prop_two">{{ row.sucursal }}</span>

                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="creacion">
                  <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> FECHA DE CREACION
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.fechaCreacion}}"><span
                    class="mobile-label">Fecha de Creacion: </span>
                    <div class="block">
                      <span class="prop_two">{{ row.fechaCreacion }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef class=" headerCell pr-0"> ESTATUS</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                    <span class="mobile-label">STATUS:</span>
                    @if (row.estatusReceta === 'Activa') {
                      <span class="badge badge-solid-green">{{ row.estatusReceta }}</span>
                    }
                    @if (row.estatusReceta === 'Surtida') {
                      <span class="badge badge-solid-blue">{{ row.estatusReceta }}</span>
                    }
                    @if (row.estatusReceta === 'Cancelada') {
                      <span class="badge badge-solid-red">{{ row.estatusReceta }}</span>
                    }
                    @if (row.estatusReceta === 'Vencida') {
                      <span class="badge badge-solid-brown">{{ row.estatusReceta }}</span>
                    }
                    @if (row.estatusReceta === 'Surtida Parcialmente') {
                      <span class="badge badge-solid-yellow">{{ row.estatusReceta }}</span>
                    }
                    @if (row.estatusReceta === 'Vencida Surtida Parcialmente') {
                      <span class="badge badge-solid-purple">{{ row.estatusReceta }}</span>
                    }
                  </mat-cell>
                </ng-container>

                <!-- actions -->
                <ng-container matColumnDef="acciones">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                    <div class="acciones-container" data-tour="rx-actions-cell">
                      <div>
                        <button
                          data-tour="rx-action-view"
                          (click)="$event.stopPropagation(); goToDetails(row)"
                          class="tbl-fav-std"
                          mat-icon-button>
                          <mat-icon color="primary">visibility</mat-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          data-tour="rx-action-edit"
                          *ngIf="!row.timbrada && row.estatusReceta !== 'Cancelada' && (isDoctor || isParticular)"
                          (click)="$event.stopPropagation(); editarReceta(row)"
                          mat-icon-button
                          matTooltip="Editar receta">
                          <app-feather-icons class="btn-edit" [icon]="'edit-3'"></app-feather-icons>
                        </button>
                      </div>
                      <div>
                        <button
                          data-tour="rx-action-pdf"
                          (click)="$event.stopPropagation(); descargarPDF(row)"
                          *ngIf="row.generarPDF && row.timbrada && row.estatusReceta !== 'Cancelada'"
                          class="tbl-fav-std" mat-icon-button>
                          <app-feather-icons class="btn-download" [icon]="'download'"></app-feather-icons>
                        </button>
                      </div>
                      <div>
                        <button
                          (click)="$event.stopPropagation(); enviarRecetaPorCorreo(row)"
                          *ngIf="row.generarPDF && row.timbrada && row.estatusReceta !== 'Cancelada'"
                          class="tbl-fav-std"
                          mat-icon-button
                          matTooltip="Enviar receta por correo">
                          <mat-icon color="primary">mail</mat-icon>
                        </button>
                      </div>
                      <div>
                        <button data-tour="rx-action-timbrar"
                                *ngIf="!row.timbrada && row.estatusReceta !== 'Cancelada' && (isDoctor || isParticular)"
                                (click)="$event.stopPropagation(); timbrarReceta(row)"
                                mat-icon-button
                                matTooltip="Timbrar Receta">
                          <app-feather-icons class="btn-timbrar" [icon]="'upload-cloud'"></app-feather-icons>
                        </button>
                      </div>

                      <div>
                        <button
                          data-tour="rx-action-delete"
                          (click)="$event.stopPropagation(); deleteItem(row)"
                          *ngIf="(isDoctor || isParticular) && !row.folio && row.estatusReceta !== 'Cancelada'"
                          class="tbl-action-btn" mat-icon-button
                        >
                          <app-feather-icons [class]="'tbl-fav-delete'" [icon]="'trash-2'"></app-feather-icons>
                        </button>
                      </div>
                    </div>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumns;"
                  [class.fila-destacada]="row.importante"
                  matRipple>
                </mat-row>
              </table>
              @if (data?.isTblLoading) {
                <div class="tbl-spinner">
                  <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                  </mat-progress-spinner>
                </div>
              }
              @if (!data?.isTblLoading) {
                <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                  SIN RESULTADOS
                </div>
              }
              <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             [pageSize]="10">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
